// @todo: Migrate to 'Tabs' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as Tabs from '@wandb/weave/components/Tabs';
import React, {useMemo, useState} from 'react';

import {SettingsContentWrapper} from '../components/SettingsContentWrapper';
import {useWorkspaceInheritedSettingsForPanel} from '../hooks/useWorkspaceInheritedSettingsForPanel';
import {useMediaSettingsDrawerContext} from './MediaSettingsDrawerContextProvider';
import {MediaSettingsDrawerSection} from './MediaSettingsDrawerSection';
import {SettingsLevel} from './types';
import {getMediaSettingsTabs} from './util';

export const MediaSettingsDrawerContent = ({
  header,
  description,
  settingsLevel,
}: {
  header: React.ReactNode;
  description: string;
  settingsLevel: SettingsLevel;
}) => {
  const {mediaCardTypes, config, hasMasks, hasBoundingBoxes, rampFlags} =
    useMediaSettingsDrawerContext();
  const inheritedSettings = useWorkspaceInheritedSettingsForPanel();
  const tabs = useMemo(
    () =>
      getMediaSettingsTabs(
        mediaCardTypes ?? null,
        config,
        hasMasks,
        hasBoundingBoxes,
        settingsLevel,
        rampFlags,
        inheritedSettings.media
      ),
    [
      mediaCardTypes,
      config,
      hasMasks,
      hasBoundingBoxes,
      rampFlags,
      settingsLevel,
      inheritedSettings.media,
    ]
  );
  const [selectedTab, setSelectedTab] = useState<string | undefined>(
    tabs?.[0]?.title
  );
  return (
    <SettingsContentWrapper
      title="Media panel"
      description={description}
      header={header}>
      <Tabs.Root value={selectedTab ?? ''} onValueChange={setSelectedTab}>
        <Tabs.List>
          {tabs.map(({title}) => (
            <Tabs.Trigger key={title} data-test={title} value={title}>
              {title}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {selectedTab && (
          <Tabs.Content value={selectedTab} tabIndex={-1}>
            <div data-test="media-settings-drawer-content">
              {tabs
                .find(tab => tab.title === selectedTab)
                ?.sections.map(section => (
                  <MediaSettingsDrawerSection
                    key={section.title}
                    {...section}
                  />
                ))}
            </div>
          </Tabs.Content>
        )}
      </Tabs.Root>
    </SettingsContentWrapper>
  );
};
